import { render, staticRenderFns } from "./SocietyFormDetails.vue?vue&type=template&id=6496c368&scoped=true&"
import script from "./SocietyFormDetails.vue?vue&type=script&lang=js&"
export * from "./SocietyFormDetails.vue?vue&type=script&lang=js&"
import style0 from "./SocietyFormDetails.vue?vue&type=style&index=0&id=6496c368&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6496c368",
  null
  
)

export default component.exports